import React from 'react';

const PlatformAgreement = () => {
  return (
    <>
      <h3 style={{ textAlign: 'center' }}>BlueSana</h3>
      <h4 style={{ textAlign: 'center' }}>Platform User Agreement (“PUA”)</h4>
      <h4 style={{ textAlign: 'center' }}>Effective date: March 2024</h4>
      <ol>
        <li style={{ marginTop: 20 }}>
          This PUA is between the person registering for a user account (
          <strong>"User”</strong>), any entity that the User represents (
          <strong>"Entity”</strong>) and BlueSana Pty Ltd (ABN 15 661 711 977) (
          <strong>“BlueSana”</strong>). In this PUA, the User and Entity are
          collectively referred to as “You”.
        </li>
        <li style={{ marginTop: 20 }}>
          BlueSana operates an internet platform designed to present, to
          Permitted Investors (as defined in clause 3, below), a selection of
          investment opportunities in businesses and organisations allocating
          financial resources towards projects, initiatives, and technologies
          that aim to mitigate the impacts of climate change and/or promote the
          transition to a low-carbon, sustainable economy (
          <strong>“Platform”</strong>).
        </li>
        <li style={{ marginTop: 20 }}>
          Permitted Investors are those Investors that meet the following
          criteria and are not Excluded Investors:
          <ol type="a">
            <li>
              <strong>Australia:</strong> a person who is a ‘wholesale client’
              as defined in section 761G of the Corporations Act 2001 (Cth). By
              accepting the terms of the PUA You represent and warrant that You
              and or your Entity are a ‘wholesale client’. Should You proceed
              with any investment opportunity identified on the Platform You
              will need to satisfy the ‘wholesale investor’ requirement prior to
              making your investment.
            </li>
            <li>
              <strong>Outside Australia:</strong> if You are outside Australia,
              a person to whom an invitation or offer to subscribe for shares,
              and any issue of such shares is permitted by the laws of the
              jurisdiction in which You are situated without the need for any
              registration, lodgement or other formality.
            </li>
          </ol>
        </li>

        <li style={{ marginTop: 20 }}>
          Excluded Investors are those Investors that are a:
          <ol type="a">
            <li>
              US Person as defined in Regulation S under the Securities Act of
              1933 (United States of America); or
            </li>
            <li>
              Person, entity or resident subject to any sanctions implemented
              under the Charter of the United Nations Act 1945 (Cth) or the
              Autonomous Sanctions Act 2011 (Cth).
            </li>
          </ol>
        </li>

        <li style={{ marginTop: 20 }}>
          BlueSana may revise the PUA at any time. Notice of any change to the
          terms of the PUA will be given on the Platform.
        </li>

        <li style={{ marginTop: 20 }}>
          BlueSana is a Corporate Authorised Representative (CAR No 13 08 973)
          of Avenir Capital Pty Ltd (ACN 150 790 355) (<strong>“Avenir”</strong>
          ). Avenir holds an Australian Financial Services Licence
          (AFSL 405469).
        </li>

        <li style={{ marginTop: 20 }}>
          In order to access the Platform, You are required to register an
          account with BlueSana (<strong>“User Account”</strong>).
        </li>

        <li style={{ marginTop: 20 }}>
          In order to create a User Account, You are required to provide
          BlueSana with:
          <ol type="a">
            <li>
              Your registration information such as your name, address, email
              address, phone number and location (or if a corporate entity your
              nominated persons registration information);
            </li>
            <li>A username and password.</li>
          </ol>
        </li>

        <li style={{ marginTop: 20 }}>
          You warrant that the registration information You provide to BlueSana
          is accurate, and will be kept accurate and up to date.
        </li>

        <li style={{ marginTop: 20 }}>
          You understand that by supplying BlueSana your address, email address
          and phone number, You may receive regular emails, newsletters,
          telephone calls or SMS updates from BlueSana. If You do not wish to
          receive updates You may contact us at{' '}
          <a href="mailto:contact@bluesana.com.au">contact@bluesana.com.au</a>
        </li>

        <li style={{ marginTop: 20 }}>
          We collect information from You for the purposes of providing You with
          the services available through our Platform. We do this through
          obtaining information from You and we hold it and disclose it in
          accordance with our Privacy Policy.
        </li>

        <li style={{ marginTop: 20 }}>
          By registering for a User Account, You represent and warrant to
          BlueSana that:
          <ol type="a">
            <li>
              You have the right, authority and capacity to agree to and abide
              by the terms of the PUA;
            </li>
            <li>
              You are a Permitted Investor and are not an Excluded Investor;
            </li>
            <li>
              if You are the User who is registering with BlueSana in an
              individual capacity and not on behalf of an Entity, the User
              agrees to the terms of the PUA;
            </li>
            <li>
              if You are registering on behalf of an Entity, the User is duly
              authorised to be capable of binding the Entity to the PUA, and
              that both the User and the Entity have agreed to the terms of the
              PUA; and
            </li>
            <li>
              You will use the Platform in a manner consistent with any and all
              applicable laws, regulations and the PUA.
            </li>
          </ol>
        </li>

        <li style={{ marginTop: 20 }}>
          You agree not to share your User Account with any other person (except
          with the officers or employees of the User’s entity for the legitimate
          needs of the User’s entity’s business) and to notify BlueSana
          following any unauthorised use of your User Account.
        </li>

        <li style={{ marginTop: 20 }}>
          BlueSana reserves the right to remove your User Account or close your
          access to the Platform for any reason whatsoever, including (but not
          limited to) if it is found that You are not a sophisticated or
          professional investor or a wholesale client or the information You
          provide is considered to be incorrect, not current, false, misleading
          or deceptive, offensive or does not comply with applicable laws,
          standards or regulations.
        </li>

        <li style={{ marginTop: 20 }}>
          BlueSana reserves the right to charge Users a platform user fee,
          however, any such fees are presently waived by BlueSana.
        </li>

        <li style={{ marginTop: 20 }}>
          By accessing the Platform and agreeing to the terms of the PUA You:
          <ol type="a">
            <li>
              acknowledge and agree that neither BlueSana nor Avenir are
              offering to issue, sell or deal in any financial product, nor are
              they purporting to give You any advice, whether general or
              specific, with respect to any financial product shown on the
              Platform;
            </li>
            <li>
              represent and warrant that in making any investment of which You
              became aware via the Platform You will not rely on any
              representation or warranty made by BlueSana or any of its related
              entities and that You are capable of undertaking Your own due
              diligence and assessing the risks of any investment and that You
              will consult with your tax, legal and/or financial planning
              advisors before making a decision to invest;
            </li>

            <li>
              acknowledge and agree that the issuer of any financial product
              shown on the platform (<strong>“Issuer”</strong>) is solely
              responsible for the accuracy and sufficiency of any information
              made available on the Platform;
            </li>
            <li>
              acknowledge and agree that BlueSana may charge and retain as its
              own Issuer fees related to their use of the Platform, including a
              fee contingent upon the completion of any investment by an
              Investor or any of its related entities, including as a percentage
              of the amount of such investment;
            </li>

            <li>
              acknowledge and agree that links to third party websites on the
              Platform are provided solely for your convenience. If You use
              these links, You leave the Platform. You further acknowledge and
              agree that BlueSana does not monitor and may not have reviewed any
              of these third party websites and does not control and is not
              responsible for these websites or their content or availability.
              BlueSana therefore does not endorse or make any representations
              about them, or any material found there, or any results that may
              be obtained from using them. If You decide to access any of the
              third party websites linked to the Platform, You do so entirely at
              your own risk;
            </li>

            <li>
              acknowledge and agree that investing in early stage securities is
              a high risk strategy which means You can potentially lose all the
              money You invest;
            </li>

            <li>
              agree to confirm in writing the details of any participation by
              You in any offering made by an Issuer on the Platform, including
              but not limited to the date, the number of shares purchased, and
              the total amount paid. You agree to provide such confirmation
              within 14 days of a request in writing from BlueSana to You; and
            </li>
            <li>
              irrevocably authorise BlueSana to access any shareholder data
              relating to You and your participation in any offering made by an
              Issuer on the Platform.
            </li>
          </ol>
        </li>

        <li style={{ marginTop: 20 }}>
          By accessing any part of the Platform dedicated to a particular
          offering by an Issuer including any information in a private data room
          (<strong>“Asset Page”</strong>), You recognise and acknowledge the
          competitive value and confidential nature of all the information on
          the Asset Page (<strong>"Confidential Information”</strong>) and agree
          that all information available on the Asset Page is confidential for
          the benefit of both BlueSana and the Issuer. For the avoidance of
          doubt, Confidential Information does not include information which is
          generally known to the public or is in the public domain other than as
          a result of a breach of confidentiality.
        </li>

        <li style={{ marginTop: 20 }}>
          You agree that You will keep the contents of each Asset Page
          confidential and take all reasonable steps to protect the confidential
          nature of the Confidential Information, and that You will not cause or
          permit the release, reproduction, or disclosure of Confidential
          Information to any other party in any way other than:
          <ol type="a">
            <li>
              with the prior written consent of the Issuer and BlueSana; or
            </li>
            <li>
              to your legal, tax, accounting or financial advisors for the
              purposes of obtaining advice about the potential investment and
              only in circumstances where the recipient acknowledges the
              confidential nature of the information and agrees to keep it
              confidential.
            </li>
          </ol>
        </li>

        <li style={{ marginTop: 20 }}>
          Unless otherwise stated, the copyright and other intellectual property
          rights in all material on the Platform (including without limitation
          photographs and graphical images) are owned or licensed by BlueSana
          (or its licensors).
        </li>

        <li style={{ marginTop: 20 }}>
          You retain ownership of the intellectual property rights (things such
          as copyright or trademarks) in any such content that You create and
          share on the Platform. However, to provide our services, You grant
          BlueSana a non-exclusive, transferable, sub-licensable, royalty-free
          and worldwide licence to host, use, distribute, modify, run, copy,
          publicly perform or display, translate and create derivative works of
          your content.
        </li>

        <li style={{ marginTop: 20 }}>
          You agree that You are capable of undertaking your own due diligence
          on any Investment shown on the Platform, and that You are solely
          responsible for the selection and engagement of your own legal, tax,
          accounting or financial advisors, at your own cost. You agree that
          BlueSana provides You with no advice in relation to any investment,
          and that any decision to invest or not invest is solely your own.
          Accordingly, BlueSana disclaims any and all liability arising directly
          or indirectly from any investment decision You take in relation to any
          investment shown on the Platform.
        </li>

        <li style={{ marginTop: 20 }}>
          You release BlueSana and its officers, contractors and employees from
          all sums of money, accounts, claims, actions, proceedings, demands and
          expenses which You at any time have or had against BlueSana and or its
          related entities arising out of the Platform or your use of the
          Platform and anything done or omitted to be done by You or any other
          party in respect of the Platform or compliance with any laws.
        </li>

        <li style={{ marginTop: 20 }}>
          You indemnify BlueSana from: any losses incurred by BlueSana; all
          liabilities incurred by BlueSana; and all costs actually payable by
          BlueSana to its own legal representatives (whether or not under a
          costs agreement) and other expenses incurred by BlueSana in connection
          with a demand, action, arbitration or other proceeding (including
          mediation, compromise, out of court settlement or appeal); in
          connection with: a breach of the PUA by You; your investment with any
          Issuer; anything done or omitted to be done by You or others in
          connection to your use of the Platform; the failure to comply with any
          laws by You or others; or any acts or omissions of You or your agents,
          employees or contractors.
        </li>

        <li style={{ marginTop: 20 }}>
          You will hold harmless BlueSana, its officers, contractors and
          employees and will indemnify those parties jointly and severally
          against any claim, demand or loss which may be suffered arising, in
          any way whatsoever, from any investment made in a financial product
          issued by an Issuer which You were introduced to via the Platform.
        </li>

        <li style={{ marginTop: 20 }}>
          Subject to any liability which cannot be excluded under the relevant
          laws, BlueSana disclaims all liability to any person relying on the
          information contained on the Platform in respect of any loss or damage
          (including consequential loss or damage), however caused, which may be
          suffered or arise directly or indirectly in respect of such
          information.
        </li>

        <li style={{ marginTop: 20 }}>
          Information on the BlueSana Platform is for general information only,
          and has not been prepared taking into account any person’s objectives,
          financial situation or needs. Unless otherwise clear from its context,
          the information contained on the BlueSana Platform is not intended to
          be relied upon as a forecast and is not a recommendation, offer or
          solicitation to buy or sell any securities or to adopt any investment
          strategy, nor is it investment advice.
        </li>
        <li style={{ marginTop: 20 }}>
          Past performance is not a reliable indicator of future performance.
          Any forwarding-looking statements or forecasts are based on reasonable
          assumptions, but cannot be relied upon as guarantees or representation
          as to what future performance will actually occur. Unless otherwise
          specified, the information contained on the BlueSana Platform is
          current as at the date indicated on the information and all amounts
          are in Australian Dollars (AUD).
        </li>
        <li style={{ marginTop: 20 }}>
          You agree that this Agreement and your use of the Platform does not
          give rise to any relationship of agency as between You and BlueSana.
          You agree that this Agreement does not appoint either party as the
          agent, partner or legal representative of the other for any purposes
          whatsoever, and neither party shall have any express or implied right
          or authority to assume or to create any obligation or responsibility
          on behalf of or in the name of the other party. You agree that this
          Agreement does not create any relationship of trust or fiduciary duty
          as between You and BlueSana.
        </li>
        <li style={{ marginTop: 20 }}>
          Governing Law: This Agreement is governed by and interpreted in
          accordance with the laws of New South Wales and each party submits to
          the exclusive jurisdiction of New South Wales.
        </li>
        <li style={{ marginTop: 20 }}>
          Assignment: You cannot assign or otherwise transfer your rights under
          this Agreement without the prior written consent of BlueSana. BlueSana
          may, at any time, assign its rights and obligations under this
          Agreement, including to a related entity or in connection with any
          transaction including in relation to a sale of assets, merger,
          acquisition, reorganisation, insolvency, or by operation of law.
        </li>
        <li style={{ marginTop: 20 }}>
          Entire Agreement: This Agreement constitutes the entire agreement of
          the parties relating to this Agreement and supersedes all prior
          understandings, negotiations, agreements, written or oral, express or
          implied, in relation thereto.
        </li>
        <li style={{ marginTop: 20 }}>
          Severability: Every clause and sub-clause of this Agreement will,
          where the context permits, be severable from every other without
          invalidating or affecting the remaining provisions of this Agreement
          or the validity of that provision in any other jurisdiction.
        </li>
        <li style={{ marginTop: 20 }}>
          Waiver: A waiver by one party does not prejudice its right in respect
          of any subsequent breach of this Agreement by the other party. A party
          does not waive its rights under this Agreement because it grants an
          extension or other forbearance to the other party.
        </li>
      </ol>
    </>
  );
};

export default PlatformAgreement;
